"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var React = require("react");
var validation_1 = require("../lib/validation");
exports.AmplitudeContext = React.createContext({
    eventProperties: {},
});
function useAmplitudeContext() {
    return React.useContext(exports.AmplitudeContext);
}
exports.useAmplitudeContext = useAmplitudeContext;
function initAmplitude(amplitudeInstance, apiKey, userId, config) {
    return function () {
        if (validation_1.isValidAmplitudeInstance(amplitudeInstance)) {
            if (apiKey) {
                amplitudeInstance.init(apiKey, undefined, config);
            }
            if (userId) {
                amplitudeInstance.setUserId(userId);
            }
        }
    };
}
function AmplitudeProvider(props) {
    var amplitudeInstance = props.amplitudeInstance, apiKey = props.apiKey, userId = props.userId, config = props.config;
    var init = React.useMemo(function () { return initAmplitude(amplitudeInstance, apiKey, userId, config); }, [
        amplitudeInstance,
        apiKey,
        userId,
        config,
    ]);
    init();
    return (React.createElement(exports.AmplitudeContext.Provider, { value: {
            amplitudeInstance: props.amplitudeInstance,
            eventProperties: {},
        } }, props.children));
}
exports.AmplitudeProvider = AmplitudeProvider;
AmplitudeProvider.propTypes = {
    amplitudeInstance: PropTypes.object.isRequired,
    apiKey: PropTypes.string,
    userId: PropTypes.string,
    config: PropTypes.object,
};
